import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment-timezone';

interface Props {
    timestamp: number;
    children: React.ReactElement
}

function TimestampTooltip(props: Props) {
    const { timestamp, children } = props;
    return (
        <Tooltip title={`${moment(timestamp).format('ddd, MMM Do YYYY, HH:mm z')} ${moment.tz.zone(moment.tz.guess()).abbr(timestamp)}`}>
            {children}
        </Tooltip>
    );
};

export default TimestampTooltip;
